import { Expose } from "class-transformer";

export class BulkDeductErrorDto {
  @Expose()
  row: number;

  @Expose()
  data: {
    reference: string;
    name: string;
    quantity: string;
  };

  @Expose()
  error: string;
}
